import React from 'react';

interface ProgressPoint {
  label: string;
  completed: boolean;
  role: string;
}

interface ProgressBarProps {
  points: ProgressPoint[];
  containerWidth?: string;
}

const MultiProgressBar: React.FC<ProgressBarProps> = ({ points, containerWidth }) => {
  return (
    <div className="w-full flex flex-col items-center">
      {/* Progress Bar */}
      <div className={`relative w-full flex items-center`} style={{ width: containerWidth }} >
        <div className="absolute w-full h-2 bg-gray-300 rounded"></div>
        <div className="absolute h-2 bg-blue-500 rounded transition-all" style={{ width: `${(points?points?.filter(p => p.completed).length / points.length:0) * 100}%` }}></div>
        <div className="relative z-10 flex w-full justify-between">
          {points?.map((point, index) => (
            <div key={index} className="flex flex-col items-center">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-white font-bold transition-all ${
                  point.completed ? 'bg-blue-500' : 'bg-gray-300'
                }`
              }
              onClick={()=>console.log(point)}
              >
                {index + 1}
              </div>
              <span className="mt-2 text-sm text-gray-700">{point.role || point.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MultiProgressBar;
